<template>
  <a-form-item label="标题">
    <dynamic-input v-model:template="editor.meta.title_template" :preview="editor.meta.preview.title"
                   :templates="material.titles.filter(editor.meta.tags)"
                   @preview="args => editor.meta.preview.title = args"
                   @update="args => editor.meta.title_template = args"/>
  </a-form-item>
  <a-form-item label="活动时间">
    <a-flex vertical gap="small">
      <span><a-range-picker v-model:value="info.date_range" :disabled-date="disabledDate"
                            @calendarChange="onRangePickerChange" :allowClear="false" show-time
                            :disabled="[editor.meta.publish_at,editor.meta.publish_at && dayjs(editor.meta.end_at).isBefore(dayjs())]"/></span>
    </a-flex>
  </a-form-item>
  <a-form-item label="弹幕">
    <a-switch v-model:checked="atmosphere.opt.is_barrage" checked-children="开" un-checked-children="关"/>
  </a-form-item>
  <a-form-item label="背景音乐">
    <a-button @click="() => info.music.show=true">
      <icon-font :type="`icon${atmosphere.opt.music_url ? '' : '-no'}-music`"/>
      {{ atmosphere.musicName(atmosphere.opt.music_url) }}
    </a-button>
  </a-form-item>
  <a-form-item v-if="theme.theme_id == null" label="背景图片">
    <single-upload-view v-model:image="theme.images[3][0].image_url" showUploadButton
                        :showUploadList="{showRemoveIcon: false, showDownloadIcon: false}"/>
  </a-form-item>
  <a-drawer v-model:open="info.music.show" title="背景音乐" placement="right">
    <a-space direction="vertical" class="music-option">
      <a-upload accept=".mp3" :data="(f:UploadFile) => session.ossSign(f,10 * 1024 * 1024)"
                action="https://activity-guandb-cn.oss-cn-shanghai.aliyuncs.com"
                :max-count="1" @change="onUploadChange">
        <a-button size="large">上传</a-button>
        <template #itemRender="{file}">
          <audio-item v-if="file.status == 'done'" name="自定义音乐" :active="atmosphere.opt.music_url == file.url"
                      :url="file.url"
                      :play-stat="atmosphere.active.audio.url == file.url && atmosphere.active.audio.playing"
                      @click="setMusic(file.url)"/>
        </template>
      </a-upload>
      <a-button v-if="atmosphere.opt.music_url" size="large" @click="setNoMusic">不用音乐</a-button>
    </a-space>
    <a-tabs>
      <a-tab-pane v-for="c in atmosphere.musicLibrary" :key="c.name" :tab="c.name">
        <a-list :data-source="c.data"
                :pagination="{defaultPageSize:10,hideOnSinglePage:true,showSizeChanger:false}">
          <template #renderItem="{ item }">
            <audio-item :active="atmosphere.opt.music_url == item.url" :url="item.url" :name="item.name"
                        :play-stat="atmosphere.active.audio.url == item.url && atmosphere.active.audio.playing"
                        @click="setMusic(item.url)"/>
          </template>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>

<script setup lang="ts">

import {IconFont} from "@/lib/util";
import AudioItem from "@/views/editor/service/atmosphere/atmosphere/AudioItem.vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {computed, reactive} from "vue";
import Atmosphere from "@/views/editor/service/atmosphere/atmosphere/index";
import {UploadFile} from "ant-design-vue";
import {session} from "@/model/session";
import SingleUploadView from "@/views/share/SingleUploadView.vue";
import dayjs, {Dayjs} from "dayjs";
import DynamicInput from "@/views/editor/components/system/DynamicInput.vue";
import {Material} from "@/model/material";

const router = useRoute()
const editor = router.meta.editor as AEditor;
const atmosphere = computed(() => editor.biz.active.atmosphere as Atmosphere)
const theme = editor.meta.theme[editor.active.preview.status]
const material = router.meta.material as Material;
const info = reactive({music: {show: false}, date_range: [dayjs(editor.meta.begin_at), dayjs(editor.meta.end_at)]})

const disabledDate = (date: Dayjs) => {
  if (info.date_range.length == 0) return false
  let tooEarly = date.valueOf() < new Date().valueOf()
  const tooLate = info.date_range[1].diff(date, 'days') > 30 || date.valueOf() < new Date().valueOf()
  return tooEarly || tooLate
}

const onRangePickerChange = (v: Dayjs[]) => {
  if (v.length != 2) return
  editor.meta.begin_at = v[0].toISOString()
  editor.meta.end_at = v[1].toISOString()
}

/***
 ==========    音乐      =============
 */

const onUploadChange = (j: Record<string, UploadFile>) => {
  if (j.file.status == 'done') {
    atmosphere.value.opt.music_url = j.file.url ?? ''
  }
}

const setNoMusic = () => {
  atmosphere.value.opt.music_url = ''
  atmosphere.value.active.audio.url = ''
  atmosphere.value.audio.pause()
  atmosphere.value.audio.src = ''
  atmosphere.value.active.audio.playing = false
}

const setMusic = (url: string) => {
  if (atmosphere.value.opt.music_url == url && atmosphere.value.active.audio.playing) atmosphere.value.audio.pause()
  else {
    atmosphere.value.opt.music_url = url
    atmosphere.value.active.audio.url = url
    atmosphere.value.audio.src = url
    atmosphere.value.audio.play()
    atmosphere.value.audio.loop = true
  }
}

</script>

<style scoped lang="sass">

.music-option
  display: flex
  flex-flow: row nowrap
  margin-bottom: 12px

.ant-upload-wrapper
  display: flex
  flex-flow: row nowrap

  .ant-upload-list-item-container > div
    margin: 0 12px 0 12px


</style>